<template>
  <div class="statistics-pg">
    <Search/>
    <v-container>
      <div class="breadcrumb-wrap">
        <v-breadcrumbs :items="breadcrumbs"/>
      </div>
      <div class="position">
        <div class="bg-white p-20">
          <h1 class="title-pg">{{ $t('Таблица для мониторинга Единого портала') }}</h1>
          <div v-if="id == 1" class="statistics-item">
            <h4>{{ $t('Учтённые комментарии') }}</h4>
            <div class="table-overflow">
              <table>
                <thead>
                <tr>
                  <td class="td-num">№</td>
                  <td>{{ $t('Содержание комментария') }}</td>
                  <td>{{ $t('Государственный орган которым учтен комментарий') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in statistics" :key="item.c_id">
                  <td class="td-num">{{ index + 1 }}</td>
                  <td>
                    <div :id="item.c_id" class="text-collapse-wrap">
                      <div
                        class="text-collapse"
                        :class="{ height_inherit: item.visible === true || item.c_text.length <= maxLength }"
                      >
                        <router-link
                          :title="item.c_text | strippedContent"
                          :to="$i18nRoute({
                          name: 'view-npa',
                          params: { id: item.n_id },
                          query: { comment: item.c_id, ver:item.v_id, block: item.b_id ? item.b_lang+'_'+item.b_id : null }
                        })"
                          :key="item.id"
                        >
                          <div v-html="item.c_text"></div>
                        </router-link>
                      </div>
                      <div v-if="!item.visible && item.c_text.length > maxLength" class="project-goal-gradient"></div>
                    </div>
                    <template v-if="item.c_text.length > maxLength">
                      <br/>
                      <a
                        class="btn-collapse"
                        :aria-expanded="item.visible ? 'true' : 'false'"
                        :aria-controls="String(item.c_id)"
                        @click="item.visible = !item.visible"
                        :href="'#' + item.c_id"
                      >{{ item.visible ? $t("Свернуть") : $t("Показать") }}</a>
                    </template>
                  </td>
                  <td class="text-center">
                    {{ item.d_name }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="id == 2" class="statistics-item">
            <h4>{{ $t('Не отвеченные комментарии') }}</h4>
            <div class="table-overflow">
              <table>
                <thead>
                <tr>
                  <td
                    v-for="(item, index) in headerTable2"
                    :key="index"
                  >
                    <Sorting
                      v-if="item.sorting"
                      :item="item"
                      :filterable="item.filterable"
                      :currentOrderKey="orderBy"
                      @order="sortData($event)"
                      @filter="sortingFilterHandler($event)"
                      @cancelSorting="cancelSorting()"
                    />
                    <span v-else>
                      {{ item.name }}
                    </span>
                  </td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in statistics" :key="item.c_id">
                  <td class="td-num">{{ index + 1 }}</td>
                  <td>
                    <div :id="item.c_id" class="text-collapse-wrap">
                      <div
                        class="text-collapse"
                        :class="{ height_inherit: item.visible === true || item.c_text.length <= maxLength }"
                      >
                        <router-link
                          :title="item.c_text | strippedContent"
                          :to="$i18nRoute({
                          name: 'view-npa',
                          params: { id: item.n_id },
                          query: { comment: item.c_id, ver:item.v_id, block: item.b_id ? item.b_lang+'_'+item.b_id : null }
                        })"
                          :key="item.id"
                        >
                          <div v-html="item.c_text"></div>
                        </router-link>
                      </div>
                      <div v-if="!item.visible && item.c_text.length > maxLength" class="project-goal-gradient"></div>
                    </div>
                    <template v-if="item.c_text.length > maxLength">
                      <br/>
                      <a
                        class="btn-collapse"
                        :aria-expanded="item.visible ? 'true' : 'false'"
                        :aria-controls="String(item.c_id)"
                        @click="item.visible = !item.visible"
                        :href="'#' + item.c_id"
                      >{{ item.visible ? $t("Свернуть") : $t("Показать") }}</a>
                    </template>
                  </td>
                  <td>
                    <template v-if="item.a_nick_name">
                      {{ item.a_nick_name }}
                    </template>
                    <template v-else-if="item.a_email">
                      {{ item.a_email }}
                    </template>
                    <template v-else>
                      {{ item.a_fio }}
                    </template>
                  </td>
                  <td>{{ new Date(item.c_date) | dateFormat('DD.MM.YYYY') }}</td>
                  <td>{{ item.d_name }}</td>
                  <td>
                    <template v-for="(category, i) in item.categories">
                      <span :key="category.id">
                        {{ category.transName }}
                        <span v-if="i+1 != item.categories.length">, </span>
                      </span>
                    </template>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="id == 3" class="statistics-item">
            <h4>{{ $t('Ответы , которые даны с нарушением срока') }}</h4>
            <div class="table-overflow">
              <table>
                <thead>
                <tr>
                  <td class="td-num">№</td>
                  <td>{{ $t('Государственный орган') }}</td>
                  <td>{{ $t('Содержание комментария') }}</td>
                  <td>{{ $t('Дата публикации комментария') }}</td>
                  <td>{{ $t('Ответ государственного органа') }}</td>
                  <td>{{ $t('Количество просроченных дней') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in statistics" :key="item.c_id">
                  <td class="td-num">
                    {{ index + 1 }}
                  </td>
                  <td>{{ item.d_name }}</td>
                  <td>
                    <div :id="item.c_id" class="text-collapse-wrap">
                      <div
                        class="text-collapse"
                        :class="{ height_inherit: item.commentVisible === true || item.c_text.length <= maxLength }"
                      >
                        <router-link
                          :title="item.c_text | strippedContent"
                          :to="$i18nRoute({
                          name: 'view-npa',
                          params: { id: item.n_id },
                          query: { comment: item.c_id, ver:item.v_id, block: item.b_id ? item.b_lang+'_'+item.b_id : null }
                        })"
                          :key="item.id"
                        >
                          <div v-html="item.c_text"></div>
                        </router-link>
                      </div>
                      <div v-if="!item.commentVisible || item.c_text.length > maxLength"
                           class="project-goal-gradient"></div>
                    </div>
                    <br/>
                    <a
                      class="btn-collapse"
                      :aria-expanded="item.commentVisible ? 'true' : 'false'"
                      :aria-controls="String(item.c_id)"
                      @click="item.commentVisible = !item.commentVisible"
                      :href="'#' + item.c_id"
                    >{{ item.commentVisible ? $t("Свернуть") : $t("Показать") }}</a>
                  </td>
                  <td class="text-center">
                    {{ new Date(item.c_date) | dateFormat('DD.MM.YYYY') }}
                  </td>
                  <td class="td-answer">
                    <div :id="item.c_id + '_' + item.a_id" class="text-collapse-wrap">
                      <div
                        :class="{ height_inherit: item.visible === true, 'text-collapse': true }"
                        v-html="item.a_text"
                      >
                      </div>
                      <div v-if="!item.visible" class="project-goal-gradient"></div>
                    </div>
                    <template v-if="item.a_text.length > maxLength">
                      <br/>
                      <a
                        class="btn-collapse"
                        :aria-expanded="item.visible ? 'true' : 'false'"
                        :aria-controls="item.c_id + '_' + item.a_id"
                        @click="item.visible = !item.visible"
                        :href="'#' + item.c_id + '_' + item.a_id"
                      >{{ item.visible ? $t("Свернуть") : $t("Показать") }}</a>
                    </template>
                  </td>
                  <td class="text-center">
                    {{ item.date_diff }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import Search from '@/components/Search'
import NPA from '@/model/npa'
import { mapGetters, mapMutations } from 'vuex'
import {Trans} from "@/plugins/Translation"
import mixin from '@/plugins/mixin/mixin'
import Sorting from "@/components/app/Sorting"
import Api from "@/model/api"

export default {
  mixins: [mixin],
  components: {
    Search,
    Sorting
  },
  data: () => ({
    id: null,
    breadcrumbs: [],
    statistics: [],
    maxLength: 280,
    search: {},
    orderBy: 'date',
    orderDir: 'desc',
    refCategory: [],
    refDeveloper: [],
    page: 1,
  }),
  metaInfo() {
    return {
      title: this.$i18n.t('CommentStatisticsTitleSEO'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.$i18n.t('CommentStatisticsDescriptionSEO'),
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.$i18n.t('CommentStatisticsKeywordsSEO'),
      }]
    }
  },
  mounted() {
    this.fetchData()
    this.scrollToTop()
  },
  computed: {
    ...mapGetters({
      searchData: 'getSearchData'
    }),
    headerTable2() {
      const fields = [
        {name: '№', key: 'id', sorting: false},
        {name: this.$t('Содержание комментария'), key: 'text', sorting: true},
        {name: this.$t('Публичное имя автора комментария'), key: 'author', sorting: true},
        {name: this.$t('Дата публикации'), key: 'date', sorting: true},
        {
          name: this.$t('Государственный орган которому оставили комментарий'),
          key: 'developer',
          sorting: true,
          filterable: true,
          filterItems: this.refDeveloper
        },
        {name: this.$t('Категории'), key: 'category', sorting: true, filterable: true, filterItems: this.refCategory},
      ]
      return fields
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
      this.setLoading(true)
      this.id = this.$route.params.id
      this.breadcrumbs = [
        {text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/'},
        {text: this.$i18n.t('Таблица для мониторинга Единого портала'), disabled: true}
      ]
      if (this.id == 2) {
          this.refCategory = this.searchData.refCategory
          this.refDeveloper = this.searchData.refDeveloper
      }
      this.commentStatistics()
      this.setLoading(false)
    },
    commentStatistics() {
      this.setLoading(true)
      this.search.orderBy = this.orderBy
      this.search.orderDir = this.orderDir
      NPA.getCommentStatistics(this.$route.params.id, this.search).then((response) => {
        this.statistics = response.data
      })
        .catch((error) => {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: error.response.status
            }
          }))
        })
      this.setLoading(false)

    },
    sortData(sort) {
      this.orderBy = sort.key
      this.orderDir = sort.value
      this.commentStatistics()
    },
    sortingFilterHandler(filter) {
      this.search[filter.name] = filter.value
      this.commentStatistics()
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    cancelSorting () {
      this.orderBy = 'date'
      this.orderDir = 'desc'
      this.commentStatistics()
    }
  }
}
</script>
